import { Carousel, CarouselArrowNavigation, CarouselWrapper } from '$partials/base/carousel';
import React from 'react';
import { SwiperSlide } from 'swiper/react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').TestimonialCarousel}
 */

const TestimonialCarousel = ({
    heading,
    testimonials
}) => {

    const swiperConfig = {
        slidesPerView: 'auto',
        spaceBetween: 0
    };

    return (
        <div className='module-testimonial-carousel theme-light bg-main-background'>
            <div className='py-16 sm:py-40 md:py-48'>
                <Carousel swiperConfig={swiperConfig}>
                    <div className='flex flex-col gap-y-24 w-full mx-auto'>
                        {/* Header with title and controls */}
                        <div className='layout-container layout-site-outer-padding w-full flex items-center justify-end gap-16'>
                            {/* Title */}
                            {heading && (
                                <h2 className='type-style-2 text-main-text-primary w-full'>
                                    {heading}
                                </h2>
                            )}
                            {/* Controls */}
                            <div className='hidden sm:flex'>
                                <CarouselArrowNavigation />
                            </div>
                        </div>

                        {/* Carousel */}
                        <div className='overflow-hidden w-full max-w-screen left-1/2 relative -translate-x-1/2'>
                            <div className='layout-container layout-site-outer-padding overflow-visible'>
                                <div className='col-wrapper'>
                                    <CarouselWrapper>
                                        {testimonials?.map((testimonial, index) => (
                                            <SwiperSlide
                                                className='w-10/12 sm:w-5/12 md:w-4/12 flex'
                                                key={testimonial.id || index}>
                                                <blockquote className='col-padding'>
                                                    {testimonial?.quote && (
                                                        <p className='type-style-4 text-main-text-primary w-full mb-16'>
                                                            &ldquo;{testimonial.quote}&rdquo;
                                                        </p>
                                                    )}
                                                    {testimonial?.role && (
                                                        <cite className='type-style-eyebrow text-main-text-primary not-italic block'>
                                                            {testimonial.role}
                                                        </cite>
                                                    )}
                                                    {testimonial.name && (
                                                        <cite className='type-style-eyebrow text-main-text-primary mt-4 not-italic block'>
                                                            {testimonial.name}
                                                        </cite>
                                                    )}
                                                </blockquote>
                                                <div className={`shrink-0 w-[1px] h-full bg-main-border ${index === testimonials.length - 1 ? 'hidden' : ''}`} />
                                            </SwiperSlide>
                                        ))}
                                    </CarouselWrapper>
                                </div>
                            </div>
                        </div>
                    </div>
                </Carousel>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default TestimonialCarousel;
